import BaseModal from "../../components/BaseModal";
import { FestaProduct } from "../../interfaces/FestaProduct";
import { ModalInterface } from "../../interfaces/ModalInterface";

export default function ProductModal(props: ModalInterface<FestaProduct>) {
  const { modal, setModal } = props;

  return modal.selected ? (
    <BaseModal modal={modal} setModal={setModal}>
      {modal.selected.sleeve ? (
        <div className="mb-2">
          <label className="text-xl text-gray-600">슬리브: </label>
          <label className="text-xl text-gray-700 font-semibold">
            {modal.selected.sleeve}
          </label>
        </div>
      ) : (
        <></>
      )}
    </BaseModal>
  ) : (
    <></>
  );
}
